import {
  Alert, Button,
  Col, FormInput,
  FormInputCheckbox,
  FormInputSelect, FormInputText
} from 'camino-react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'

import NextSectionButtons from 'Components/Tickets/Form/Sections/NextSectionButtons'

import ContactMethodFields from './Client/ContactMethodFields'
import ContactFields from './ContactFields'

class TicketCreateFormSectionsContacts extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      clients: props.clients,
      users: props.users || [],
      clientContactsLoading: false,
      clientNoticesContent: []
    }
  }

  handleClientContactSelectChange = (newClientContactId) => {
    const { clients } = this.state
    const { setFieldValue, client_id } = this.props

    setFieldValue('client_contact_id', newClientContactId)

    const selectedClient = _.find(clients, { id: client_id }) || {}
    const selectedClientUser = _.find(selectedClient.users, { id: newClientContactId }) || {}

    setFieldValue('primary_contact_name', selectedClientUser.label)
    setFieldValue('primary_contact_email', selectedClientUser.email)
  }

  toggleSecondaryContactFieldForGuest = () => {
    const { showSecondaryContactFieldForGuest } = this.state
    event.preventDefault()
    this.setState({
      showSecondaryContactFieldForGuest: !showSecondaryContactFieldForGuest
    })
  }

  render () {
    const {
      clients,
      clientContactsLoading,
      clientNoticesContent,
      showSecondaryContactFieldForGuest
    } = this.state

    const {
      hidden,
      creatingContact,
      creatingContactForClient,
      currentUser,
      submitAction,
      submitButtonText,
      policy,
      setFieldValue,
      assign_to_current_user,
      primary_contact_name: primaryContactName,
      primary_contact_email: primaryContactEmail,
      client_name: clientName,
      preferred_contact_method,
      contact_number,
      setFieldErrorClasses,
      regionMetadata,
      chosenLocation,
      locations,
      queue_id,
      addClientHandler,
      clientsPropertiesWithHandlers,
      bulkCreation,
      handleAssignToMe,
      setNextModalSection,
      secondary_contact_email,
      addClientContactListToClient,
      refreshContacts,
      disabled_contact_notifications: disabledContactNotifications,
      security_issue: securityIssue,
      disableNext
    } = this.props

    const queueOptions = _.map(currentUser.queues, queue => ({ label: queue.name, value: queue.id }))

    if (hidden) { return null }

    return (
      <div>
        {disabledContactNotifications && (
          <Alert type="info">
            No customer notifications will be sent out, as they have been
            disabled. These can be re-enabled under Company Information.
          </Alert>
        )}

        <label>
          {currentUser.calligo_employee || currentUser.has_additional_clients ? 'Who is the client contact?' : 'What is the preferred method of contact?'}
        </label>
        <br />

        <div className="flex flex--columned">
          {(!currentUser.calligo_employee && !currentUser.has_additional_clients) && (
            <ContactMethodFields {...{
              currentUser,
              setFieldErrorClasses,
              setFieldValue,
              preferred_contact_method,
              contact_number,
              primaryContactEmail
            }}
            />
          )}

          <ContactFields {...{
            creatingContact,
            creatingContactForClient,
            currentUser,
            primaryContactName,
            primaryContactEmail,
            clientName,
            setFieldErrorClasses,
            setFieldValue,
            clients,
            clientNoticesContent,
            regionMetadata,
            chosenLocation,
            refreshContacts,
            locations,
            clientsPropertiesWithHandlers,
            addClientContactListToClient,
            contactNumber: contact_number,
            disabledContactNotifications,
            securityIssue
          }}
          />

        </div>
        <br />
        {!creatingContact && currentUser.calligo_employee && (
          <Button
            onClick={() => { addClientHandler() }}
            size="compact"
            outline
          >
            <span className="lnr lnr-plus lnr-inline" />
            Add Client
          </Button>
        )}

        {policy('tickets', 'ticketAssigneeUser') && currentUser.calligo_employee && !bulkCreation && (
          <div>
            <FormInputCheckbox onValue={value => handleAssignToMe(value)} value={assign_to_current_user}>
              Assign to me
            </FormInputCheckbox>
          </div>
        )}

        {assign_to_current_user && (!_.isEmpty(currentUser.queues)) && !bulkCreation && (
          <FormInput label="Please select a queue">
            <FormInputSelect
              options={queueOptions}
              value={_.find(queueOptions, ['value', queue_id])}
              onValue={value => setFieldValue('queue_id', value)}
              className={setFieldErrorClasses('queue_id')}
            />
          </FormInput>
        )}

        {assign_to_current_user && (_.isEmpty(currentUser.queues)) && !bulkCreation && (
          <Alert
            type="error"
            title="You are not assigned to any queue. The option: 'assign to me' is only
                  available if you are assigned to at least one queue."
          />
        )}

        {currentUser.isGuestUser && (
          <div className="row no-gutters" style={{ alignItems: 'center' }}>
            {showSecondaryContactFieldForGuest && (
              <Col width={19}>
                <FormInput label="Secondary Contact Email">
                  <FormInputText
                    value={secondary_contact_email}
                    onValue={value => setFieldValue('secondary_contact_email', value)}
                  />
                </FormInput>
              </Col>
            )}

            <Col width={showSecondaryContactFieldForGuest ? 5 : 24}>
              <button onClick={event => this.toggleSecondaryContactFieldForGuest(event)} type="button" className="button button--link" style={showSecondaryContactFieldForGuest ? {} : { padding: 'initial' }}>
                <span style={{ border: '0' }} className={`lnr ${showSecondaryContactFieldForGuest ? 'lnr-minus' : 'lnr-plus'} lnr-inline lnr-black lnr-small`} />
                {' '}
                {showSecondaryContactFieldForGuest ? 'Remove' : 'Add Secondary Contact'}
              </button>
            </Col>
          </div>

        )}
        {!creatingContact && <NextSectionButtons setNextModalSection={() => setNextModalSection('TicketType')} disabled={disableNext} />}

      </div>
    )
  }
}

TicketCreateFormSectionsContacts.propTypes = {
  policy: PropTypes.func.isRequired,
  primary_contact_name: PropTypes.string,
  primary_contact_email: PropTypes.string,
  preferred_contact_method: PropTypes.string,
  client_name: PropTypes.string,
  contact_number: PropTypes.string,
  setFieldValue: PropTypes.func.isRequired,
  paths: PropTypes.shape({
    apiClientsPath: PropTypes.string.isRequired,
    usersApiClientsPath: PropTypes.string.isRequired
  }).isRequired
}

TicketCreateFormSectionsContacts.defaultProps = {
  primary_contact_name: '',
  primary_contact_email: '',
  client_name: '',
  preferred_contact_method: '',
  contact_number: ''
}

export default TicketCreateFormSectionsContacts
